<gd-hello-bar></gd-hello-bar>
<router-outlet></router-outlet>
